<template>
    <signView :viewType="1">
        <template  v-slot:mainCenter>
            <div class="login_box">
                <div class="login_item">
                    <div class="login_from">
                        <h1 class="centerText bold_primaryText" style="margin-bottom:50px">Administrator Log In</h1>
                        <!--<p class="primaryText marginTB centerText">
                            Take your business to the next level. Lorem ipsum <br/>
                            dolor sit amet, consectetur adipiscing elit.
                        </p>-->
                        <el-input autocomplete="off" v-model="email" class="myLogin_input" maxlength="100" 
                        :class="{'is-error':emptyEmail||!isSuccessFormat}" @blur="valid(1)" 
                        placeholder="Email address or mobile number" @keyup.enter.native="login"></el-input>
                        <transition name="el-fade-in">
                            <p v-show="!isSuccessFormat" class="error_msg">The email format entered is incorrect.</p>
                        </transition>
                        <el-input autocomplete="new-password" type="password" maxlength="16" v-model="password" :class="{'is-error':emptyPassword}" @blur="valid(2)" class="myLogin_input marginTB_input" placeholder="Password" @keyup.enter.native="login"></el-input>
                        <div class="default_Btn" :class="{'loading_btn':loading}" @click="login">Login
                            <i v-show="loading" class="el-icon-loading my_loading_icon"></i>
                        </div>
                        <p class="forget_password" @click="$router.push('/forget-password')">Forgot password</p>
                        <p class="primaryText login_foot centerText">
                            By signing in, you agree to our <br/>
                            terms of service and privacy policy.
                        </p>
                    </div>
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/4c70d3514be74e4e8ba7c4b79d089e44.png" class="login_icon" alt="">
                </div>
            </div>
        </template>
    </signView>
</template>

<script>
import api from '../../api/login'
import md5 from 'js-md5'
import signView from '../common/sign-view.vue'
export default {   
    components:{signView},
    data() {
        return {
            isSuccessFormat:true,
            loading:false,
            email:'',
            password:'',
            emptyEmail:false,
            emptyPassword:false
        }
    },
    methods: {
        valid(key){
            switch (key) {
                case 1:
                    this.emptyEmail = this.email?false:true
                    /*if(!this.emptyEmail){
                        this.emptyEmail = false
                        this.isSuccessFormat = Utils.isEmail(this.email)
                    }*/
                    break;
                case 2:
                    this.emptyPassword = this.password?false:true
                    break;
            }
        },
        login(){
            if(this.loading) return
            this.valid(1)
            this.valid(2)
            if(this.emptyEmail||this.emptyPassword||!this.isSuccessFormat) return
            if(this.password.split('').length<8||this.password.split('').length>16){
                Utils.alert('','Please enter a password of 8-16 digits','error')
                return
            }
            this.loading = true
            const pat = {
                userEmail:this.email,
                password:md5(this.password)
            }
            api.signIn(pat,res=>{
                const {code,message} = res.data;
                this.loading = false
                if(code == 200){
                    const token = res.headers['benycompany-satoken']
                    window.localStorage.setItem('TOKEN_KEY',token)
                    // window.location.herf = (`https://web.beny.com.au/#/oa/home?token=${token}`)
                    var obj = document.createElement('a');
                    obj.href = `https://web.beny.com.au/#/oa/home?beny=${token}`;
                    obj.click();
                    Utils.alert('',message,'success')
                }else{
                    Utils.alert('',message,'error')
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.login_box{
    min-height: calc(100vh - 128px);
    padding-top: 77px;
    // overflow: hidden;
    .login_item{
        display: flex;
        width: 1220px;
        margin: 0 auto;
        .login_from{
            width: 445px;
            min-width: 445px;
            margin-top: 156px;
            .marginTB{
                opacity: 1;
                margin: 20px 0 30px 0;
            }
            .marginTB_input{
                margin: 16px 0 24px 0;
            }
            .forget_password{
                text-align: center;
                text-decoration: underline;
                cursor: pointer;
                font-size: 14px;
                font-family: Assistant-Bold, Assistant;
                font-weight: bold;
                color: #F8A4AE;
                line-height: 16px;
                margin-top: 20px;
            }
            .login_foot{
                font-size: 15px;
                opacity: 0.8;
                margin-top: 24px;
                line-height: 18px;
            }
            /deep/{
                .myLogin_input{
                    height: 55px;
                    .el-input__inner{
                        height: 55px;
                        line-height: 55px;
                        background: #4e4c4a;
                        border-color: #4e4c4a;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .login_icon{
            margin-left: auto;
            width: 740px;
            height: 722px;
            margin-right: -89px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/sign/login.vue